/* Marcel Afters: home shop rail, Her | Him | Unisex (HOME-SHOP, 25 Sep 2026). Markup: sections/ma-shop-tabs.liquid.
   Tabs (click, arrow keys, Home/End), arrow buttons that step by the visible cards, and a position line.
   Scrolling itself is native (scroll-snap); nothing here listens to the wheel or moves the page. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function arm(root) {
    if (root._maSt) return;
    root._maSt = true;
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    var alls = [].slice.call(root.querySelectorAll('.ma-st__all'));

    function panelOf(tab) { return document.getElementById(tab.getAttribute('aria-controls')); }
    function sync(panel) {
      if (!panel || panel.hidden) return;
      var track = panel.querySelector('.ma-st__track');
      var prev = panel.querySelector('.ma-st__arrow--prev'), next = panel.querySelector('.ma-st__arrow--next');
      var thumb = panel.querySelector('.ma-st__thumb');
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      var img = track.querySelector('.ma-st__img');
      if (img) panel.style.setProperty('--st-img-h', img.getBoundingClientRect().height + 'px');
      if (thumb) {
        var bar = thumb.parentElement.getBoundingClientRect().width;
        var frac = max > 0 ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
        var w = Math.max(24, bar * frac);
        thumb.style.width = w + 'px';
        thumb.style.setProperty('--st-x', (max > 0 ? (track.scrollLeft / max) * (bar - w) : 0) + 'px');
      }
    }
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = panelOf(t);
        if (p) p.hidden = !on;
      });
      var id = tab.getAttribute('aria-controls').split('-p-').pop();
      alls.forEach(function (a) { a.hidden = a.dataset.tab !== id; });
      if (focus) tab.focus();
      var p = panelOf(tab);
      if (p) requestAnimationFrame(function () { sync(p); });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j === null) return;
        e.preventDefault();
        select(tabs[j], true);
      });
    });

    [].forEach.call(root.querySelectorAll('.ma-st__panel'), function (panel) {
      var track = panel.querySelector('.ma-st__track');
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; sync(panel); });
      }, { passive: true });
      // Shift + mouse wheel scrolls the row sideways where the browser does not already do it (deltaX stays 0).
      track.addEventListener('wheel', function (e) {
        if (!e.shiftKey || e.deltaX !== 0 || !e.deltaY) return;
        var max = track.scrollWidth - track.clientWidth;
        if ((e.deltaY < 0 && track.scrollLeft <= 0) || (e.deltaY > 0 && track.scrollLeft >= max - 1)) return;
        e.preventDefault();
        track.scrollLeft += e.deltaY;
      }, { passive: false });
      [].forEach.call(panel.querySelectorAll('.ma-st__arrow'), function (b) {
        b.addEventListener('click', function () {
          var item = track.querySelector('.ma-st__item');
          var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
          var w = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
          var cs = getComputedStyle(track);
          var inner = track.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) + gap;
          var per = Math.max(1, Math.floor(inner / w));
          track.scrollBy({ left: w * per * Number(b.dataset.dir), behavior: reduce.matches ? 'auto' : 'smooth' });
        });
      });
      if ('ResizeObserver' in window) new ResizeObserver(function () { sync(panel); }).observe(track);
      sync(panel);
    });
    window.addEventListener('load', function () { [].forEach.call(root.querySelectorAll('.ma-st__panel'), sync); });
  }

  function run() { [].forEach.call(document.querySelectorAll('[data-ma-st]'), arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
